import React from "react";

export default function Schema() {
  return (
    <div className="text-center mb-4">
      <span>Votre Assurance Decennale</span>
      <a href="https://www.votre-assurance-decennale.fr">
        www.votre-assurance-decennale.fr
      </a>
      <br />
      <a
        target="_blank"
        href="https://f1.np6.com/form.aspx?GV1=SASH0310000000000000000000000278"
      >
        Politique de confidentialité
      </a>{" "}
      -{" "}
      <a
        target="_blank"
        href="https://f1.np6.com/form.aspx?GV1=SASH031000000000000000000000027B"
      >
        Conditions générales
      </a>{" "}
      - <a href="javascript:consentDisplayPopup();">Cookies</a>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
{
  "@context": "https://schema.org",
  "@type": "InsuranceAgency",
  "name": "Votre Assurance Decennale",
  "url": "https://www.votre-assurance-decennale.fr",
  "image": "https://www.votre-assurance-decennale.fr/logo.png",
  "address": {
    "@type": "PostalAddress",
    "country": "FR",
    "addressCountry": "France",
    "addressLocality": "LORMONT",
    "postalCode": "33310",
    "streetAddress": "14 rue Jean Blandin"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4",
    "ratingCount": "256",
    "bestRating": "5"
  }
}`,
        }}
      />
    </div>
  );
}
